import { useQuery } from "@tanstack/react-query";

import { CreditTiersQueryKeys } from "./creditTiersQueryKeys";
import {
  getCreditTiers,
  GetCreditTiersQueryParams,
} from "@/api/creditTiers";

export const useCreditTiers = (
  filters: GetCreditTiersQueryParams & { enabled?: boolean }
) => {
  return useQuery({
    queryKey: [CreditTiersQueryKeys.All, filters],
    enabled: filters.enabled ?? true,
    queryFn: ({ signal }) => {
      const params = { feature: filters.feature };
      return getCreditTiers({ signal, params });
    },
  });
};
